import clsx from "clsx";
import PropTypes from "prop-types";
import makeStyles from "@material-ui/core/styles/makeStyles";

const useStyles = makeStyles((theme) => ({
	root: {
		marginBottom: theme.spacing(5),
		[theme.breakpoints.up("md")]: {
			marginRight: theme.spacing(2)
		},
		"&:last-child": {
			marginRight: theme.spacing(0)
		}
	},
	topWrapper: {
		marginBottom: theme.spacing(2)
	},
	title: {
		fontWeight: theme.typography.fontWeightBold
	},
	link: {
		color: theme.palette.common.white,
		display: "table",
		"&:hover": {
			textDecoration: "underline"
		}
	}
}));

const Contact = ({ data }) => {
	const css = useStyles();

	return data?.map(({ id, title, street, phone, mail01, mail02 }, index) => {
		return (
			<div className={clsx("contact-" + index, css.root)} key={id}>
				<div className={clsx("top-wrapper", css.topWrapper)}>
					{title && <p className={clsx("title", css.title)}>{title}</p>}
					{street && <p className={clsx("street")}>{street}</p>}
				</div>
				{phone && (
					<a
						className={clsx("phone", css.link)}
						href={clsx("tel:" + phone.replace(/\D/g, ``))}
					>
						{phone}
					</a>
				)}
				{mail01 && (
					<a className={clsx("mail01", css.link)} href={clsx("mailto:" + mail01)}>
						{mail01}
					</a>
				)}
				{mail02 && (
					<a className={clsx("mail02", css.link)} href={clsx("mailto:" + mail02)}>
						{mail02}
					</a>
				)}
			</div>
		);
	});
};

Contact.propTypes = {
	data: PropTypes.array.isRequired
};

export default Contact;
